// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__sKjSl"};